export enum ShowInfoEnum {
  points = " ... ",
}

export enum ShowInfoTabs {
  PhysicalArtOnLocation = "Physical Art on Location",
  OurVirtualShow = "Our Virtual Art Show",
}
